export default __webpack_public_path__ + "static/licensingImage-103cece0e8b9d29528e06eb8c2000892.svg";